import React, {PureComponent} from 'react';
import ApngComponent from 'react-apng';

let APNG_SUPPORTED = false;

(function() {
    var image = new Image();
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    image.onload = function() {
        if (typeof canvas.getContext === 'undefined') {
            return false;
        } else {
            ctx.drawImage(image, 0, 0);
            APNG_SUPPORTED = ctx.getImageData(0, 0, 1, 1).data[3] === 0;
        }
    };

    image.src =
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACGFjVEwAAAABAAAAAcMq2TYAAAANSURBVAiZY2BgYPgPAAEEAQB9ssjfAAAAGmZjVEwAAAAAAAAAAQAAAAEAAAAAAAAAAAD6A+gBAbNU+2sAAAARZmRBVAAAAAEImWNgYGBgAAAABQAB6MzFdgAAAABJRU5ErkJggg==';
})();

export default class Apng extends PureComponent {
    render() {
        if (APNG_SUPPORTED) {
            return <img {...this.props} />;
        }
        return <ApngComponent autoPlay={true} {...this.props} />;
    }
}



// WEBPACK FOOTER //
// ./src/atoms/Apng.js